"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetConfig = exports.removeConfig = exports.addConfig = exports.initialState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var models_1 = require("../../../models");
exports.initialState = {
    activeConfigs: {},
};
var dynamicRenderSlice = toolkit_1.createSlice({
    name: 'dynamicRender',
    initialState: exports.initialState,
    reducers: {
        addConfig: function (state, action) {
            var _a, _b, _c, _d, _e, _f;
            switch (action.payload.id) {
                case models_1.DynamicRenderConfigId.carYear: {
                    state.activeConfigs = __assign(__assign({}, state.activeConfigs), (_a = {}, _a[models_1.DynamicRenderConfigId.carYear] = action.payload, _a));
                    break;
                }
                case models_1.DynamicRenderConfigId.insuredValue: {
                    state.activeConfigs = __assign(__assign({}, state.activeConfigs), (_b = {}, _b[models_1.DynamicRenderConfigId.insuredValue] = action.payload, _b));
                    break;
                }
                case models_1.DynamicRenderConfigId.allowedProducts: {
                    state.activeConfigs = __assign(__assign({}, state.activeConfigs), (_c = {}, _c[models_1.DynamicRenderConfigId.allowedProducts] = action.payload, _c));
                    break;
                }
                case models_1.DynamicRenderConfigId.allowedBrands: {
                    state.activeConfigs = __assign(__assign({}, state.activeConfigs), (_d = {}, _d[models_1.DynamicRenderConfigId.allowedBrands] = action.payload, _d));
                    break;
                }
                case models_1.DynamicRenderConfigId.allowedModels: {
                    state.activeConfigs = __assign(__assign({}, state.activeConfigs), (_e = {}, _e[models_1.DynamicRenderConfigId.allowedModels] = action.payload, _e));
                    break;
                }
                case models_1.DynamicRenderConfigId.userInterface: {
                    state.activeConfigs = __assign(__assign({}, state.activeConfigs), (_f = {}, _f[models_1.DynamicRenderConfigId.userInterface] = action.payload, _f));
                    break;
                }
                default: {
                    // empty case
                }
            }
        },
        removeConfig: function (state, action) {
            state.activeConfigs[action.payload] = undefined;
        },
        resetConfig: function (state) {
            state.activeConfigs = {};
        },
    },
});
exports.default = dynamicRenderSlice.reducer;
exports.addConfig = (_a = dynamicRenderSlice.actions, _a.addConfig), exports.removeConfig = _a.removeConfig, exports.resetConfig = _a.resetConfig;
//# sourceMappingURL=dynamicRenderSlice.js.map